module.exports = __webpack_public_path__ + "img/skymarket.ccc37b8b.jpeg";